import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import toast from "@/utils/toast";

import "@/utils/permission";
import "@/utils/register/registerServiceWorker";
import "@/utils/register/registerGlobalComponents";
import "swiper/dist/css/swiper.css";
import "./styles/index.scss";

Vue.use(VueAwesomeSwiper);
Vue.prototype.$toast = toast;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
